export enum StatusCode {
  Ok = 0,
  InvalidCredentials = 1,
  AccountIsNotReachable = 2,
  EmailIsNotRegistered = 3,
  UserNotExternal = 7,
  AccountIsLocked = 11,
  InvalidClientName = 12,
  SSOonly = 13,
  InvalidSsoClientConfig = 20,
  InvalidSamlToken = 21,
  InvalidEmail = 23,
}
